<div class="booking-header">
  <div class="steps-wrapper flex-centered">
    <markant-platform-booking-step
      [bookingStep]="bookingStep"
    ></markant-platform-booking-step>
  </div>

  <markant-seperator class="separator"></markant-seperator>

  <div class="flex-row-centered">
    <div class="text">
      <p class="headline">
        {{
          'booking.form.bookingOf'
            | transloco: { serviceName: cartridgeVariantName }
        }}
      </p>
      <span class="subheadline" *ngIf="bookingStep === 'form'">{{
        'booking.form.startSubheadline' | transloco
      }}</span>
      <span class="subheadline" *ngIf="bookingStep === 'confirmation'">{{
        'booking.confirmation.subheadline' | transloco
      }}</span>
    </div>
  </div>
</div>
